module.exports = __webpack_public_path__ + "img/CarolineBartlett-PollySutton-FerneJacobs.6cae47e2.jpg";